import React, { useContext, useEffect, useState } from "react";
import "../styles/modalbox.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteVehicle,
  rentVehicle,
  reserveVehicle,
  showAlert,
  updateCar,
} from "../redux/actions";
import { useTranslation } from "react-i18next";
import { Carcontext } from "../context/carcontext";
import { fCurrency } from "../utils";

const edit = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fal"
    data-icon="edit"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
  >
    <path
      fill="currentColor"
      d="M417.8 315.5l20-20c3.8-3.8 10.2-1.1 10.2 4.2V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h292.3c5.3 0 8 6.5 4.2 10.2l-20 20c-1.1 1.1-2.7 1.8-4.2 1.8H48c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V319.7c0-1.6.6-3.1 1.8-4.2zm145.9-191.2L251.2 436.8l-99.9 11.1c-13.4 1.5-24.7-9.8-23.2-23.2l11.1-99.9L451.7 12.3c16.4-16.4 43-16.4 59.4 0l52.6 52.6c16.4 16.4 16.4 43 0 59.4zm-93.6 48.4L403.4 106 169.8 339.5l-8.3 75.1 75.1-8.3 233.5-233.6zm71-85.2l-52.6-52.6c-3.8-3.8-10.2-4-14.1 0L426 83.3l66.7 66.7 48.4-48.4c3.9-3.8 3.9-10.2 0-14.1z"
    ></path>
  </svg>
);
const save = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fal"
    data-icon="save"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM288 64v96H96V64h192zm128 368c0 8.822-7.178 16-16 16H48c-8.822 0-16-7.178-16-16V80c0-8.822 7.178-16 16-16h16v104c0 13.255 10.745 24 24 24h208c13.255 0 24-10.745 24-24V64.491a15.888 15.888 0 0 1 7.432 4.195l83.882 83.882A15.895 15.895 0 0 1 416 163.882V432zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 144c-30.879 0-56-25.121-56-56s25.121-56 56-56 56 25.121 56 56-25.121 56-56 56z"
    ></path>
  </svg>
);
const trash = (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fal"
    data-icon="trash-alt"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M296 432h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zm-160 0h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8zM440 64H336l-33.6-44.8A48 48 0 0 0 264 0h-80a48 48 0 0 0-38.4 19.2L112 64H8a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v368a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V96h24a8 8 0 0 0 8-8V72a8 8 0 0 0-8-8zM171.2 38.4A16.1 16.1 0 0 1 184 32h80a16.1 16.1 0 0 1 12.8 6.4L296 64H152zM384 464a16 16 0 0 1-16 16H80a16 16 0 0 1-16-16V96h320zm-168-32h16a8 8 0 0 0 8-8V152a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v272a8 8 0 0 0 8 8z"
    ></path>
  </svg>
);

const CarModalBox = (prop) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state.clients.isLoggedIn);
  const rentStartDate = useSelector((state) => state.orders.rentStartDate);
  const rentEndDate = useSelector((state) => state.orders.rentEndDate);
  const rentStartTime = useSelector((state) => state.orders.rentStartTime);
  const rentEndTime = useSelector((state) => state.orders.rentEndTime);

  const { CloseModal } = useContext(Carcontext);

  const [localClient, setLocalClient] = useState({});
  const [editable, setEditable] = useState(false);
  const [edited, setEdited] = useState({});

  const params = {
    contentEditable: editable,
    suppressContentEditableWarning: true,
  };

  const [rentData, setRentData] = useState({
    client_id: "",
    car_id: "",
    start: "",
    end: "",
    start_time: "",
    end_time: "",
  });

  useEffect(() => {
    fillAvailableField();
    const localClientStatus = JSON.parse(
      localStorage.getItem(`newCreatedUserData`)
    );
    setLocalClient(localClientStatus);
  }, [prop.cars]);

  function fillAvailableField() {
    try {
      setRentData({
        client_id: localClient.newUserId.toString(),
        car_id: prop.cars.car_id.toString(),
        start: rentStartDate,
        end: rentEndDate,
        start_time: `${rentStartTime}:00`,
        end_time: `${rentEndTime}:00`,
      });
    } catch (e) {}
  }

  function reserveCar(e) {
    e.preventDefault();
    if (!rentData.start && !rentData.end) {
      dispatch(
        showAlert("You did not set start/end dates for reserve!", "warning")
      );
    } else {
      rentData.status = "reserved";
      sendReserve();
    }
    CloseModal();
  }

  function sendReserve() {
    dispatch(reserveVehicle(rentData));
  }

  function rentCar(e) {
    e.preventDefault();
    if (!rentData.start && !rentData.end) {
      dispatch(
        showAlert("You did not set start/end dates for rent!", "warning")
      );
    } else {
      setRentData({
        ...rentData,
        status: "in progress",
      });
      sendRent();
    }
    CloseModal();
  }

  function handleUpdates(event) {
    setEdited({
      ...edited,
      [event.target.id]: event.target.innerText,
    });
  }

  function sendRent() {
    dispatch(rentVehicle(rentData));
  }

  function showAlertOccupiedUser() {
    dispatch(showAlert("This user is currently renting a car", "warning"));
    CloseModal();
  }

  function allowEdit() {
    setEditable((prev) => !prev);
  }

  function saveUpdates(e, id) {
    e.preventDefault();
    if (JSON.stringify(edited) === "{}") {
      dispatch(showAlert(`You did not change anything`, `warning`));
    } else {
      dispatch(updateCar(id, edited));
    }
    setEditable(false);
    CloseModal();
  }

  function reset() {
    for (let member in edited) delete edited[member];
    setEditable(false);
  }

  function deleteCar(e, car) {
    e.preventDefault();
    const conf = window.confirm(
      `Do you wish to delete ${car.brand} ${car.model} ?`
    );
    if (conf) {
      dispatch(deleteVehicle(car.car_id));
    }
    CloseModal();
  }

  if (!prop.cars) {
    return <div className="modal"></div>;
  }

  return (
    <div className="functional-layer" onMouseLeave={reset}>
      <div className={`modalbox ${prop.theme}`}>
        <div className={`edit ${editable}`} onClick={allowEdit}>
          {edit}
        </div>
        <div className="modalbox-top">
          <div className="modalbox-info">
            <h2 className={`modalbox-title ${editable}`}>
              <span {...params} id="brand" onInput={handleUpdates}>
                {prop.cars.brand}
              </span>{" "}
              <span {...params} id="model" onInput={handleUpdates}>
                {prop.cars.model}
              </span>
            </h2>
            <h4 className="modalbox-number year">
              {t("yearOfIssue")}:{" "}
              <p
                {...params}
                id="year_of_issue"
                className={`modalbox-price ${editable}`}
                onInput={handleUpdates}
              >
                {prop.cars.year_of_issue}
              </p>
            </h4>
            <h4 className="modalbox-number year">
              {t("toning")}:{" "}
              <p
                {...params}
                id="toning"
                className={`modalbox-price ${editable}`}
                onInput={handleUpdates}
              >
                {prop.cars.toning}
              </p>
            </h4>
            <h4 className="modalbox-number year">
              {t("totalCost")}:{" "}
              <p
                {...params}
                id="cost"
                className={`modalbox-price ${editable}`}
                onInput={handleUpdates}
              >
                {fCurrency(prop.cars.cost)}
              </p>
            </h4>
            <p
              className={`modalbox-number ${editable}`}
              {...params}
              id="car_num"
              onInput={handleUpdates}
            >
              {prop.cars.car_num}
            </p>
            <p className={`modalbox-price ${editable}`}>
              <span {...params} id="rent_cost" onInput={handleUpdates}>
                {fCurrency(prop.cars.rent_cost)}
              </span>
              {t("price/day")}
            </p>
          </div>
          <div className="modalbox-condition">
            <div className="modalbox-isactive">
              <div className={`modalbox-sign ${prop.cars.status}`}></div>
              <span className="modalbox-vacant">
                {t(`${prop.cars.status}`)}
              </span>
            </div>
            <div className="modalbox-imagebox">
              <img
                className="modalbox-image"
                src={`https://rezilizer.ru/${prop.cars.photo}`}
                alt="car: car"
              />
            </div>
          </div>
        </div>
        <div className="modalbox-content">
          <div className="modalbox-content-item">
            <h4 className="modalbox-subtitle">{t("tire")}</h4>
            <p
              className={`modalbox-descr ${editable}`}
              {...params}
              id="wheels_model"
              onInput={handleUpdates}
            >
              {prop.cars.wheels_model}
            </p>
          </div>
          <div className="modalbox-content-item">
            <h4 className="modalbox-subtitle">{t("accumulator")}</h4>
            <p
              className={`modalbox-descr ${editable}`}
              {...params}
              id="battery"
              onInput={handleUpdates}
            >
              {prop.cars.battery}
            </p>
          </div>
          <div className="modalbox-content-item">
            <h4 className="modalbox-subtitle">{t("color")}</h4>
            <p
              className={`modalbox-descr ${editable}`}
              {...params}
              id="color"
              onInput={handleUpdates}
            >
              {prop.cars.color}
            </p>
          </div>
        </div>
        <div className="for-rent">
          <div className="buttons">
            {editable ? (
              <>
                <div
                  className="rent-btn save"
                  onClick={(e) => saveUpdates(e, prop.cars.car_id)}
                >
                  <p>{t("save")}</p>
                  {save}
                </div>
                <div
                  className="rent-btn delete"
                  onClick={(e) => deleteCar(e, prop.cars)}
                >
                  <p>{t("delete")}</p>
                  {trash}
                </div>
              </>
            ) : (
              isLoggedIn &&
              prop.cars.status === "vacant" && (
                <>
                  {localClient.newUserStatus === "vacant" ? (
                    <>
                      <button
                        className="rent-btn reserve"
                        onClick={(e) => reserveCar(e)}
                      >
                        {t("reserve")}
                      </button>
                      <button className="rent-btn" onClick={(e) => rentCar(e)}>
                        {t("rent")}
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="rent-btn reserve disabled"
                        onClick={showAlertOccupiedUser}
                      >
                        {t("reserve")}
                      </button>
                      <button
                        className="rent-btn disabled"
                        onClick={showAlertOccupiedUser}
                      >
                        {t("rent")}
                      </button>
                    </>
                  )}
                </>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(CarModalBox);
